import { CSSProperties, PropsWithChildren, useMemo } from "react";

import styles from "./fluid.module.css";

interface FluidProps {
  width: number;
  spacing?: string | number;
}

const Fluid = ({ width, spacing, children }: PropsWithChildren<FluidProps>) => {
  const spacingValue = useMemo(() => {
    if (typeof spacing === "number") return `var(--spacing-${spacing}x)`;
    if (typeof spacing === "string") return spacing;
    return "var(--spacing)";
  }, [spacing]);

  return (
    <div
      className={styles.wrapper}
      style={
        {
          "--fluid-width": `${width}px`,
          "--fluid-spacing": spacingValue,
        } as CSSProperties
      }
    >
      {children}
    </div>
  );
};

export default Fluid;
